'use strict';

var Edit = require('../../../_virtual/Edit.js_commonjs-exports.js');
var interopRequireDefault = require('../../@babel/runtime/helpers/interopRequireDefault.js');
var React = require('react');
require('./utils/createSvgIcon.js');
var createSvgIcon = require('../../../_virtual/createSvgIcon.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(Edit.__exports, "__esModule", {
  value: true
});
exports["default"] = Edit.__exports.default = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _createSvgIcon = _interopRequireDefault(createSvgIcon.__exports);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');

exports["default"] = Edit.__exports.default = _default;

module.exports = exports["default"];
